/**
 * Read a `--port=PORT` CLI flag. The CLI's flag parser only understands
 * `--key=value`, so `--port 28800` arrives as the string "true"; a bare
 * `Number()` turned that into NaN and `create` carried on with it.
 */
export type PortFlag = { ok: true; port: number | undefined } | { ok: false; error: string };

export function parsePortFlag(value: string | undefined): PortFlag {
  if (value === undefined) return { ok: true, port: undefined };
  if (value === "true") {
    return { ok: false, error: "Write the port with an equals sign: --port=PORT (for example --port=18800)." };
  }
  const port = /^\d+$/.test(value) ? Number(value) : NaN;
  if (!Number.isInteger(port) || port < 1 || port > 65535) {
    return { ok: false, error: `"${value}" isn't a port number. Use --port=PORT with a number from 1 to 65535.` };
  }
  return { ok: true, port };
}
